import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "face-top-matter" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "right-actions" }

import { computed, useTemplateRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import NcActions from '@nextcloud/vue/components/NcActions';
import NcActionButton from '@nextcloud/vue/components/NcActionButton';
import NcActionCheckbox from '@nextcloud/vue/components/NcActionCheckbox';

import FaceEditModal from '@components/modal/FaceEditModal.vue';
import FaceDeleteModal from '@components/modal/FaceDeleteModal.vue';
import FaceMergeModal from '@components/modal/FaceMergeModal.vue';

import { useRouteIs } from '@services/route-is';
import { routes } from '@services/router';
import { config, setConfig } from '@services/user-config';
import * as utils from '@services/utils/common';
import { constants } from '@services/constants';
import { t } from '@services/l10n';

import BackIcon from 'vue-material-design-icons/ArrowLeft.vue';
import EditIcon from 'vue-material-design-icons/Pencil.vue';
import DeleteIcon from 'vue-material-design-icons/Close.vue';
import MergeIcon from 'vue-material-design-icons/Merge.vue';
import UnassignedIcon from 'vue-material-design-icons/AccountQuestion.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'FaceTopMatter',
},
  __name: 'FaceTopMatter',
  setup(__props) {



const route = useRoute();
const router = useRouter();
const routeIs = useRouteIs();
const editModal = useTemplateRef<InstanceType<typeof FaceEditModal>>('editModal');
const deleteModal = useTemplateRef<InstanceType<typeof FaceDeleteModal>>('deleteModal');
const mergeModal = useTemplateRef<InstanceType<typeof FaceMergeModal>>('mergeModal');

const name = computed(() => {
  return route.params.name?.toString() || '';
});

const isReal = computed(() => {
  return name.value && name.value !== constants.FACE_NULL;
});

const displayName = computed(() => {
  if (routeIs.RecognizeUnassigned) {
    return t('memories', 'Unassigned faces');
  } else if (!name.value) {
    return t('memories', 'People');
  } else if (utils.isNumber(name.value)) {
    return t('memories', 'Unnamed person');
  }
  return name.value;
});

function back() {
  router.go(-1);
}

function rename() {
  if (isReal.value) editModal.value?.open();
}

function openUnassigned() {
  router.push({
    name: routes.Recognize.name,
    params: {
      user: utils.uid!,
      name: constants.FACE_NULL,
    },
  });
}

function changeShowFaceRect() {
  setConfig('show_face_rect', !config.show_face_rect);
  utils.bus.emit('memories:timeline:hard-refresh', null);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (name.value)
      ? (_openBlock(), _createBlock(_unref(NcActions), { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(NcActionButton), {
              "aria-label": _unref(t)('memories', 'Back'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
            }, {
              icon: _withCtx(() => [
                _createVNode(BackIcon, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('memories', 'Back')) + " ", 1)
              ]),
              _: 1
            }, 8, ["aria-label"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'rename-hover': isReal.value }),
        onClick: rename
      }, _toDisplayString(displayName.value), 3)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(NcActions), { inline: 0 }, {
        default: _withCtx(() => [
          (!name.value && _unref(routeIs).Recognize && !_unref(routeIs).RecognizeUnassigned)
            ? (_openBlock(), _createBlock(_unref(NcActionButton), {
                key: 0,
                "aria-label": _unref(t)('memories', 'Unassigned faces'),
                onClick: openUnassigned,
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(UnassignedIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Unassigned faces')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label"]))
            : _createCommentVNode("", true),
          (isReal.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_unref(NcActionButton), {
                  "aria-label": _unref(t)('memories', 'Rename person'),
                  onClick: rename,
                  "close-after-click": ""
                }, {
                  icon: _withCtx(() => [
                    _createVNode(EditIcon, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('memories', 'Rename person')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"]),
                _createVNode(_unref(NcActionButton), {
                  "aria-label": _unref(t)('memories', 'Merge with different person'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (mergeModal.value?.open())),
                  "close-after-click": ""
                }, {
                  icon: _withCtx(() => [
                    _createVNode(MergeIcon, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('memories', 'Merge with different person')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"]),
                _createVNode(_unref(NcActionCheckbox), {
                  "aria-label": _unref(t)('memories', 'Mark person in preview'),
                  "model-value": _unref(config).show_face_rect,
                  onChange: changeShowFaceRect
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('memories', 'Mark person in preview')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "model-value"]),
                _createVNode(_unref(NcActionButton), {
                  "aria-label": _unref(t)('memories', 'Remove person'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteModal.value?.open())),
                  "close-after-click": ""
                }, {
                  icon: _withCtx(() => [
                    _createVNode(DeleteIcon, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('memories', 'Remove person')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(FaceEditModal, {
      ref_key: "editModal",
      ref: editModal
    }, null, 512),
    _createVNode(FaceDeleteModal, {
      ref_key: "deleteModal",
      ref: deleteModal
    }, null, 512),
    _createVNode(FaceMergeModal, {
      ref_key: "mergeModal",
      ref: mergeModal
    }, null, 512)
  ]))
}
}

})